import { useMutation } from '@/react-query/hooks/useMutation/useMutation';
import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

const useHoslogPlansRequestStatus = () => {
  const queryClient = useQueryClient();
  const { mutateAsync } = useMutation('updatePlanRequestStatus', {
    onSuccess: async (res) => {
      await queryClient.invalidateQueries({ queryKey: ['hoslog-plans-request'] });
      toast.success(res.message);
    },
    onError: (error) => {
      toast.error(error.message);
    },
  });

  return { mutateAsync };
};

export default useHoslogPlansRequestStatus;
